import React from 'react';
import IconMediafileEye from '@zvuk-b2b/react-uikit/ui/icons/MediafileEye';
import { DATA_TEST_IDS } from '../consts';
import { TEXTS } from '../texts';
import type { MediafilePosterPreviewTriggerProps } from './types';
import styles from '../index.module.scss';

export const MediafilePosterPreviewTrigger: React.FC<MediafilePosterPreviewTriggerProps> = ({
  id,
  label,
  onRequest,
  isDisabled,
}) => (
  <button
    type="button"
    className={styles.preview}
    aria-label={label}
    disabled={isDisabled}
    data-testid={DATA_TEST_IDS.PREVIEW(id)}
    onClick={onRequest}>
    <span
      className={styles.previewContent}
      data-testid={DATA_TEST_IDS.PREVIEW_CONTENT(id)}
      aria-hidden="true">
      <span
        className={styles.eye}
        data-testid={DATA_TEST_IDS.PREVIEW_EYE(id)}>
        <IconMediafileEye />
      </span>
      {TEXTS.PREVIEW}
    </span>
  </button>
);
